export default __webpack_public_path__ + "static/media/last-1.bd36b918.png";